
import request from "./request";
const apiService ={
    // 登录
    login(dataParam){
        let url = "/user/login/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.post(url,dataParam,head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 查看长三角金属浓度数据
    metaldensity(dataParam){
        let url = "/exceldata/metaldensity/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 获取重金属风险值
    metalcancerrisk(dataParam){
        let url = "/exceldata/metalcancerrisk/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 获取重金属风险值
    MetalNonCancerRisk(dataParam){
        let url = "/exceldata/MetalNonCancerRisk/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 查看社会经济因子指标数据
    socialeconomy(dataParam){
        let url = "/exceldata/socialeconomy/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 获取多环芳烃浓度
    pahsdensity(dataParam){
        let url = "/exceldata/pahsdensity/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 获取多环芳烃浓度
    pahscancerrisk(dataParam){
        let url = "/exceldata/pahscancerrisk/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },

    // -----------新接口
    // 重金属每年平均数据 - 查看
    MetalAverageAnnual(dataParam){
        let url = "/exceldata/MetalAverageAnnual";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 多环芳烃每年平均值 - 查看
    PAHsAverageAnnual(dataParam){
        let url = "/exceldata/PAHsAverageAnnual/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 土地利用面积占比 - 查看
    LandUseRatio(dataParam){
        let url = "/exceldata/LandUseRatio/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    
    // 重金属数据量 - 查看
    MetalReference(dataParam){
        let url = "/exceldata/MetalReference/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 多环芳烃数据量 - 查看
    PAHsReference(dataParam){
        let url = "/exceldata/PAHsReference/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    // 多环芳烃风险
    PAHsCancerRisk(dataParam){
        let url = "/exceldata/PAHsCancerRisk/";
        let head={
            ResponseType:'json',
            Headers:{
            }
        };
        return new Promise ((resolve,reject)=>{
            request.get(url,{params:dataParam},head).then((res)=>{
                resolve(res)
            }).catch((err)=>{
                resolve(err)
            })
        })
    },
    
}
export default apiService